import { useContext } from "react";
import RegularClassScheduleContext from "src/context/regularClassScheduleContext.js";

const useRegularClassSchedule = () => {
  const value = useContext(RegularClassScheduleContext);
  return value;
};

export default useRegularClassSchedule;
